module.exports = __webpack_public_path__ + "static/media/t2.5e9b7e12.jpg";